import { startup } from "./FeatureFlags";
import featureFlagService from "./FeatureFlagService";
import { DeveloperPage } from "./DeveloperPage";
import { genericViewFromComponent } from "@cisco-dna/react-utils";

/**
 * @param {string} id
 * @returns {boolean}
 */
export const featureFlagFilter = featureFlagService.isEnabled;

export { startup };
export const developerPage = genericViewFromComponent(DeveloperPage);
export { featureFlagService };
